import React, { useState } from "react";
import { Entry } from "../../../model/Entry"
import { Button, Card, CardActions, CardContent, CardHeader, Grid, MenuItem } from "@material-ui/core";
import { FormikProps } from "formik";
import FormSelectField from "../../Common/FormSelectField";
import AddEntryPersonalBibDialog from "./AddEntryPersonalBibDialog/AddEntryPersonalBibDialog";
import { ProductPersonalBibSettings } from "../../../model/Product";
import { Alert } from "@material-ui/lab";
import FormReadonlyField from "../../Common/FormReadOnlyField";

interface IProps extends FormikProps<Entry> {
    bibSettings: ProductPersonalBibSettings;
    onBibBought: () => void;
}

const EntryPersonalBibCard = (props: IProps) => {
    const [showAddPersonalBib, setShowAddPersonalBib] = useState(false);
    const hasPersonalBib = props.values.personalBib;

    const renderContent = () => {
        if (!hasPersonalBib) {
            return !props.bibSettings?.bibProductId ? (
                <Grid item xs={8}>
                    <Alert severity="info">Produkten saknar inställningar för personlig nummerlapp.</Alert>
                </Grid>
            ) : null;
        }

        if (!props.bibSettings) {
            return (<>
                <Grid item xs={8}>
                    <Alert severity="info">Produkten saknar inställningar för personlig nummerlapp. Utlämningsställe kan därför inte ändras.</Alert>
                </Grid>
                <Grid item xs={4}></Grid>
                {hasPersonalBib && <>
                    <Grid item xs={4}>
                        <FormReadonlyField {...props}
                            propName="handoutLocation"
                            label="Utlämningsställe"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FormSelectField {...props}
                            propName="bibSize"
                            label="Storlek"
                        >
                            <MenuItem key="S-L" value="S-L">S-L</MenuItem>
                            <MenuItem key="XL-XXL" value="XL-XXL">XL-XXL</MenuItem>
                        </FormSelectField>
                    </Grid>
                </>}
            </>);
        }

        return (<>
            <Grid item xs={4}>
                <FormSelectField {...props}
                    propName="handoutLocation"
                    label="Utlämningsställe"
                >
                    {props.bibSettings.handoutLocations.map((item) => {
                        return <MenuItem key={item} value={item}>{item}</MenuItem>
                    })}
                </FormSelectField>
            </Grid>
            <Grid item xs={4}>
                <FormSelectField {...props}
                    propName="bibSize"
                    label="Storlek"
                >
                    <MenuItem key="S-L" value="S-L">S-L</MenuItem>
                    <MenuItem key="XL-XXL" value="XL-XXL">XL-XXL</MenuItem>
                </FormSelectField>
            </Grid>

        </>);
    };

    const render = () => {
        const btnDisabled = !props.bibSettings?.bibProductId || props.dirty;

        return (<>
            <Card>
                <CardHeader
                    title="Personlig nummerlapp"
                />
                <CardContent>
                    <Grid container spacing={2} style={{ width: "100%" }}>
                        {renderContent()}
                    </Grid>
                </CardContent>
                <CardActions>
                    {!hasPersonalBib &&
                        <Button size="small" color="secondary"
                            disabled={btnDisabled}
                            onClick={() => {
                                setShowAddPersonalBib(true);
                            }}
                        >
                            Lägg till personlig nummerlapp
                        </Button>
                    }
                </CardActions>
            </Card>

            {showAddPersonalBib &&
                <AddEntryPersonalBibDialog
                    bibSettings={props.bibSettings}
                    entry={props.values}
                    onComplete={() => {
                        setShowAddPersonalBib(false);
                        props.onBibBought();
                    }}
                    onAbort={() => {
                        setShowAddPersonalBib(false);
                    }}
                />
            }
        </>);
    };

    return render();
};

export default EntryPersonalBibCard;